import {
    ButtonProps,
    Group,
    Text
} from "@mantine/core";

import {
    Field,
    Form,
    Formik
} from 'formik';
import {
    FlexiButton,
    FormikTextInput,
    PlatformFieldset
} from "@flexinet/ui-components";
import {ConfirmSignUpFormRecordSchema} from "./RecordSchema.tsx";
import {useConfirmSignUpForm} from "../hooks/useConfirmSignUpForm.tsx";
import {useResendSignUpCode} from "../hooks/useResendSignUpCode.tsx";


const ResetButton = (props: ButtonProps & { type: "button" | "submit" | "reset" | undefined }) =>
    <FlexiButton {...props}>Reset</FlexiButton>
const RegisterButton = (props: ButtonProps & { type: "button" | "submit" | "reset" | undefined }) =>
    <FlexiButton {...props} />

export const ConfirmSignUpForm = () => {

    const {
        initialValues,
        handleSubmit
    } = useConfirmSignUpForm()

    // FNP-878. Without this, a user whose code expired or never arrived has no
    // way forward from this page: they cannot sign in (unconfirmed) and
    // re-registering silently sends nothing.
    const {
        resending,
        handleResend
    } = useResendSignUpCode()


    return (
        <div>
            <Formik
                initialValues={initialValues}
                validationSchema={ConfirmSignUpFormRecordSchema}
                onSubmit={handleSubmit}
            >
                {({
                      isSubmitting,
                      values,
                      errors,
                  }) => (

                    <Form>
                        <PlatformFieldset legend={'Confirm Sign Up'}
                                          px={'xl'}
                                          mb={'xl'}>

                            <Field
                                name={'username'}
                                label={'Email'}
                                type="email"
                                description={<Text size={'0.8em'} fw={500}>i.e. john.doe@mycompany.com</Text>}
                                my={'lg'}
                                component={FormikTextInput}
                            />
                            <Field
                                name={'confirmationCode'}
                                label={'Code'}
                                description={<Text size={'0.8em'} fw={500}>received code</Text>}
                                my={'lg'}
                                component={FormikTextInput}
                            />


                            {/* FNP-878 — the recovery path. Left-aligned and
                                separated from the submit group so it reads as an
                                alternative action rather than a second submit.
                                Placed inside the fieldset because it operates on
                                the email field directly above it. */}
                            <Group justify={'space-between'}>
                                <FlexiButton
                                    type={'button'}
                                    variant={'subtle'}
                                    loading={resending}
                                    // Requires a VALID email: the resend targets
                                    // whatever is in the username field, and
                                    // Cognito counts every accepted request
                                    // against a per-user rate limit — so firing
                                    // on an empty or malformed address spends a
                                    // slot the user may need.
                                    disabled={resending || !values.username || !!errors.username}
                                    onClick={() => handleResend(values.username)}
                                >
                                    Resend code
                                </FlexiButton>

                                <Group justify={'flex-end'}>
                                    <ResetButton type={'reset'} variant={'subtle'}/>
                                    <RegisterButton variant={'filled'} disabled={isSubmitting}
                                                    type={'submit'}>Confirm</RegisterButton>
                                </Group>
                            </Group>
                        </PlatformFieldset>

                    </Form>

                )}
            </Formik>
        </div>
    )
};

